<template>
  <div id="form-purchase">
    <b-card>
      <b-row class="mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/inventory/purchase">Purchase</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>

      <form v-on:submit.prevent="postPurchase">
        <b-row>
          <b-col md="5 mb-1">
            <label class="labels">No. Purchase</label>
            <div class="form-group w-50 d-flex">
              <input
                type="text"
                class="form-control"
                v-model="model.purchaseId"
                placeholder="No. Invoice"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5">
            <label class="labels">Supplier *</label>
            <v-select
              id="mySelect"
              label="text"
              v-model="model.supplier"
              :options="supplierData"
              :reduce="(text) => text.value"
              placeholder="search supplier..."
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!model.supplier"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5 mb-1">
            <label class="labels">Purchase Date *</label>
            <div
              class="form-group"
              v-bind:class="errors.has('invoiceStartDate') ? 'has-error' : ''"
            >
              <b-form-datepicker
                type="date"
                class="form-control"
                v-bind:class="errors.has('invoiceStartDate') ? 'is-invalid' : ''"
                data-vv-as="invoiceStartDate"
                name="invoiceStartDate"
                v-model="model.purchaseDate"
                placeholder="Date"
              />
              <p v-if="errors.has('invoiceStartDate') !== null"></p>
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5">
            <label for="" class="labels">Bank Account *</label>
            <v-select
              id="mySelect"
              label="text"
              v-model="model.bankAccount"
              :options="bankList"
              :reduce="(text) => text.value"
              placeholder="select bank account"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!model.bankAccount"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col md="5">
            <label class="labels">Note </label>
            <textarea
              class="form-control h-100"
              v-model="model.purchaseNote"
              placeholder="Enter something..."
            />
          </b-col>
          <b-col md="1"></b-col>
        </b-row>

        <!-- crud 1 -->
        <b-row class="mt-5 mb-3">
          <b-col md="12" lg="12">
            <!-- <div
              class="table table-responsive mt-3 px-3 py-3"
              style="border: 1px dashed #c4c4c4; border-radius: 8px"
            > -->
            <!-- <table> -->
            <!-- <thead> -->
            <!-- <tr> -->
            <!-- <th>No</th> -->
            <!-- <th width="500">Item</th> -->
            <!-- <th width="200  " class="text-center">Quantity</th> -->
            <!-- <th width="200" class="text-center">Price</th> -->
            <!-- <th width="200  " class="text-center">Discount (%)</th> -->
            <!-- <th width="150" class="text-center">Total</th> -->
            <!-- <th class="text-center"></th> -->
            <!-- </tr> -->
            <!-- </thead> -->
            <!-- <tbody> -->
            <!-- <tr v-for="(item, i) in purchaseDataObject" :key="i" style="border: none">
                    <td style="border: none" v-text="i + 1"></td>
                    <td style="border: none">
                      <v-select
                        id="mySelect"
                        label="text"
                        v-model="item.name"
                        :options="availableItems"
                        :reduce="(text) => text.value"
                        placeholder="select item"
                        class="style-chooser"
                      >
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            :required="!item.name"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                    </td>
                    <td style="border: none">
                      <b-form-input v-model="item.quantity" class="selected text-center" />
                    </td>
                    <td style="border: none">
                      <money
                        v-bind="money"
                        v-model="item.price"
                        class="text-center form-control text-right selected small-text"
                      />
                    </td>
                    <td style="border: none">
                      <b-form-input
                        type="number"
                        v-model="item.discount"
                        class="selected text-center"
                      />
                    </td>
                 
                    <td style="border: none; margin-top: -35px !important">
                      <i class="fas fa-trash-alt text-danger pointer" @click="deleteRow(i)"></i>
                    </td>
                  </tr> -->
            <!-- <tr style="border: none">
                    <td style="border: none"></td>
                    <td style="border: none">
                      <b-link @click="addDataCash()">ADD</b-link>
                    </td>
                  </tr> -->
            <!-- <tr style="border: none">
                    <td style="border: none"></td>
                    <td style="border: none"></td>
                    <td style="border: none"></td>
                    <td style="border: none"></td>
                    <td style="border: none">
                    </td>
                    <td width="250" style="border: none" class="align-items-center d-flex">
                      
                    </td>
                    <td style="border: none">
                      
                    </td>
                  </tr> -->
            <!-- </tbody> -->
            <!-- </table> -->
            <!-- <b-row>
              <b-col md="6"></b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="3">
                  <label class="labels mt-3">Total</label>
                  </b-col>
                  <b-col md="3">
                  <money
                    v-bind="money"
                    :value="getTotal()"
                    readonly
                    class="form-control bg-white text-right selected small-text"
                  />
                  </b-col>
                </b-row>
                 <b-row>
                  <b-col md="3">
                  <label class="labels mt-3">Total Discount</label>
                  </b-col>
                  <b-col md="3">
                  <money
                    v-bind="money"
                    :value="getTotalDiscount()"
                    readonly
                    class="bg-white form-control text-right selected small-text"
                  />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                  <label class="labels mt-3">Total After Discount</label>
                  </b-col>
                  <b-col md="3">
                  <money
                    v-bind="money"
                    :value="getTotalAfterDiscount()"
                    readonly
                    class="bg-white form-control text-right selected small-text"
                  />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="3">
                  <label class="labels mt-3">Total Tax</label>
                  </b-col>
                  <b-col md="3">
                  <money
                    v-bind="money"
                    :value="getTaxValues()"
                    readonly
                    class="bg-white form-control text-right selected small-text"
                  />
                  </b-col>
                </b-row>
                 <b-row>
                  <b-col md="3">
                  <h4 class="mt-3 text-bold text-primary">Grand Total</h4>
                  </b-col>
                  <b-col md="3">
                  <money
                    v-bind="money"
                    :value="getGrandTotal()"
                    readonly
                    class="bg-white form-control text-right selected small-text"
                  />
                  </b-col>
                  <b-col md="1">
                    <p v-b-tooltip.hover.top title="PAY" class="text-success text-center pointer" style="font-size:22px;" @click="showModalPurchasePay()">
                        <font-awesome-icon icon="donate"></font-awesome-icon>
                     </p>

                  </b-col>
                </b-row>
              </b-col>
            </b-row> -->
            <!-- </div> -->
          </b-col>
        </b-row>

        <!-- crud 2 -->
        <b-row>
          <b-col class="mt-3">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr class="small-text border-bottom">
                    <th width="300">Item *</th>
                    <th class="text-center" width="160">Quantity *</th>
                    <th class="text-center" width="200">Unit Price *</th>
                    <th class="text-center" width="140">Discount (%)</th>
                    <th class="text-center" width="250">Amount</th>
                    <th class="text-center" width="150"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(selectedItem, index) in selectedItems" :key="selectedItem.uuid">
                    <td>
                      <b-form-input
                        v-model="selectedItem.name"
                        :plaintext="!selectedItem.isCustomItem"
                        required
                        class="mt-3 selected small-text"
                        placeholder="Enter Item"
                      />
                    </td>
                    <td>
                      <b-form-input
                        v-model="selectedItem.orderQuantity"
                        type="number"
                        required
                        class="mt-3 text-center selected small-text"
                        style="margin-top:15px!important;"
                        placeholder="Enter Quantity"
                      />
                    </td>
                    <td>
                      <money
                        v-bind="money"
                        v-model="selectedItem.price"
                        required
                        class="form-control text-center selected small-text"
                        style="margin-top:15px!important;"
                        placeholder="Price"
                      />
                    </td>
                    <td>
                      <b-form-input
                        v-model="selectedItem.discount"
                        type="number"
                        value="0"
                        min="0"
                        max="70"
                        class="mt-3 text-center selected small-text"
                        style="margin-top:15px!important;"
                        placeholder="Discount in %"
                      />
                    </td>
                    <td>
                      <b-form-input
                        :value="
                          selectedItem.orderQuantity * selectedItem.price -
                            (selectedItem.orderQuantity *
                              selectedItem.price *
                              selectedItem.discount) /
                              100
                        "
                        plaintext
                        type="number"
                        class="mt-3 text-center selected small-text"
                      />
                    </td>
                    <td class="text-center p-0">
                      <b-button
                        pill
                        v-b-tooltip.hover.right
                        title="Delete Row"
                        style="margin-bottom:5px!important;font-weight:bold!important;padding-top:0px!important; padding-bottom:0px!important;"
                        size="sm"
                        variant="danger"
                        @click="deleteSelectedItem(index)"
                      >
                        x
                      </b-button>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-dropdown text="Add Item" variant="dark">
              <div
                style="overflow: scroll; height: 250px; width:489px; border-bottom: 1px solid black"
              >
                <v-select
                  multiple
                  v-model="selectedItems"
                  style="width: 100%;"
                  id="mySelect"
                  label="name"
                  @input="addToSelected(availableItem.uuid)"
                  :options="availableItems"
                  :reduce="(uuid) => uuid"
                  class="style-chooser mt-1"
                  placeholder="Type to search Items"
                ></v-select>
                <b-dropdown-divider></b-dropdown-divider>
              </div>
              <!-- <b-dropdown-item-button variant="primary" @click="createCustomItem()">
                  Enter Manually
                </b-dropdown-item-button> -->
            </b-dropdown>
          </b-col>

          <b-col md="6">
            <b-row>
              <b-col md="2 mt-1">
                <p id="value" class="value-row"><b>Sub Total:</b></p>
                <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
              </b-col>
              <b-col md="3">
                <p id="value" class="float-right tax-value">
                  <b> {{ formatPrice(getSubtotalCustom()) }}</b>
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2 mt-1">
                <b id="value" class="value-row">Disc Total:</b>
                <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
              </b-col>
              <b-col md="3">
                <p id="value" class="float-right tax-value">
                  <b> {{ formatPrice(getDiscTotalCustom()) }}</b>

                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3 mt-3">
                <b id="value" class="value-row">Disc Manual:</b>
                <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
              </b-col>
              <b-col md="2">
                <p id="value" class="float-right tax-value">
                   <money
                        v-bind="money"
                        v-model="model.purchaseTotalDiscount"
                        required
                        class="form-control text-right selected small-text"
                        style="margin-top:-5px!important;"
                        placeholder="Discount"
                      />
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2 mt-1">
                <p id="value" class="value-row"><b>Total:</b></p>
                <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
              </b-col>
              <b-col md="3">
                <p id="value" class="float-right tax-value">
                  <b> {{ formatPrice(getTotalCustomOrder()) }}</b>
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2 mt-3">
                <p class="tax-values"><b>Tax *:</b></p>
              </b-col>
              <b-col md="2">
                <b-form-select
                  class="form-control tax-list"
                  v-model="model.taxValue"
                  :options="taxList"
                  required
                >
                </b-form-select>
              </b-col>
              <b-col md="1">
                <b-button
                  v-b-tooltip.hover.top
                  title="Add Tax"
                  size="sm"
                  id="btn-add"
                  @click="showModalTax()"
                  ><font-awesome-icon icon="plus"
                /></b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2 mt-1">
                <p id="value" class="value-row"><b>Total Tax:</b></p>
                <hr class="hr-tax" width="217%" style="margin-bottom: 0px!important;" />
              </b-col>
              <b-col md="3">
                <p
                  id="value"
                  class="float-right tax-value"
                  style="font-size:12px!important; margin-top:12px!important;"
                >
                  <b> {{ formatPrice(getTaxValuesCustom()) }}</b>
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2 mt-1">
                <p id="value" class="value-row" style="font-size:18px!important;">
                  <b class="text-primary labels text-bold">Grant Total:</b>
                </p>
                <hr class="hr-tax" width="227%" style="margin-bottom: 0px!important;" />
              </b-col>
              <b-col md="4">
                <span id="value" class="float-right tax-value" style="font-size:18px!important;">
                  <h5 class="text-bold">
                    {{ formatPrice(getTotalCustom()) }}
                  </h5>
                </span>
              </b-col>
              <b-col md="1">
                <p
                  v-b-tooltip.hover.top
                  title="PAY"
                  class="text-success text-center pointer"
                  style="font-size:22px;"
                  @click="showModalPurchasePay()"
                >
                  <font-awesome-icon icon="donate"></font-awesome-icon>
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mt-5 mb-4 pb-2">
          <b-col md="6">
            <b-button variant="secondary" class="btn-back float-left" @click="goBack()"
              ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
            >
          </b-col>
          <b-col md="6">
            <div v-if="loadingButton" class="float-right">
              <b-button variant="warning" disabled>
                <b-spinner small type="grow"></b-spinner>
                Loading...
              </b-button>
            </div>
            <div v-else>
              <b-button variant="primary" class="btn-back float-right" type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon>
                {{ $route.params.uuid !== undefined ? 'Update' : 'Save' }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </form>
    </b-card>
    <b-modal id="bv-modal-invoice-pay" hide-footer>
      <template v-slot:modal-title>
        <h5 class="text-transform">Down Payment</h5>
      </template>
      <form v-on:submit.prevent="doPaymentInvoice()">
        <template>
          <div class="d-block">
            <label for="">Payment Date *</label>
            <div class="form-group" v-bind:class="errors.has('paymentDate') ? 'has-error' : ''">
              <b-form-datepicker
                data-vv-as="date"
                name="date"
                v-bind:class="errors.has('date') ? 'is-invalid' : ''"
                v-validate="'required'"
                required
                type="paymentDate"
                class="form-control"
                v-model="formData.paymentDate"
                placeholder="Date"
              />
              <p v-if="errors.has('date') !== null"></p>
            </div>
            <label for="">Payment Ref Number</label>
            <b-form-input
              v-model="formData.paymentRefNumber"
              placeholder="Ref number .."
            ></b-form-input
            ><br />
            <label for="">Payment To *</label>
            <b-form-select
              :options="bankList"
              required
              v-model="formData.paymentTo"
            ></b-form-select>
            <b-row>
              <b-col md="5">
                <label class="mt-2" for="">Payment Ammount *</label>
                <money
                  v-bind="money"
                  v-model="formData.paymentAmmount"
                  required
                  class="form-control text-right small-text"
                  style="margin-top:15px!important; width: 100%;"
                  placeholder="Price"
                />
                <br />
              </b-col>
              <b-col md="7" class="mt-2">
                <b-link
                  variant="success"
                  size="sm"
                  v-b-tooltip.hover.top
                  title="review before submitting"
                  v-b-toggle.collapse-2
                  class="text-bold mt-2"
                  >Payment history</b-link
                >
                <b-collapse id="collapse-2">
                  <b-card v-if="dataPayment.length > 0">
                    <div v-for="(data, i) in dataPayment" :key="i">
                      <b-row>
                        <b-col>Date</b-col>
                        <b-col>{{ data.date }}</b-col>
                      </b-row>
                      <b-row class="mt-1">
                        <b-col>Ammount</b-col>
                        <b-col class="text-bold">
                          <p>{{ formatPrice(data.payAmmount) }}</p></b-col
                        >
                      </b-row>
                      <b-row class="mt-2">
                        <b-col>
                          <b-link class="text-danger" @click="deletePayment(i)">Delete</b-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card>
                  <b-card v-else>
                    no history
                  </b-card>
                </b-collapse>
              </b-col>
            </b-row>
            <label class="mt-2" for="">Note</label>
            <b-form-textarea
              rows="3"
              v-model="formData.paymentNote"
              placeholder="Enter Note"
            ></b-form-textarea>
          </div>
        </template>
        <b-button class="mt-4" @click="$bvModal.hide('bv-modal-invoice-pay')"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button
        >
        <b-button
          variant="primary"
          v-if="formData.paymentAmmount > 0"
          type="submit"
          class="mt-4 float-right"
          ><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon>
          <font-awesome-icon icon="save" v-else></font-awesome-icon> Submit</b-button
        >
      </form>
    </b-modal>
    <b-modal id="bv-modal-tax" hide-footer>
      <template v-slot:modal-title>
        <h5 class="text-transform">Add Tax</h5>
      </template>
      <div>
        <form v-on:submit.prevent="doAddTax()">
          <div class="d-block">
            <b-form-input v-model="formData.name" required placeholder="Enter Name"></b-form-input
            ><br />
            <b-form-input
              type="number"
              v-model="formData.value"
              required
              placeholder="Enter Value"
            ></b-form-input>
            <br />
            <label for=""><strong>Journal Account*</strong></label>
            <v-select
              id="mySelect"
              label="text"
              v-model="formData.journalAccount"
              :options="journalAccountList"
              :reduce="(text) => text.value"
              placeholder="search journal account..."
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!formData.journalAccount"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            <!-- <b-button class="mt-4" @click="$bvModal.hide('bv-modal-tax')"
            >
              ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button> -->
            <b-button variant="success" class="btn btn-sm mt-3 mb-3 float-right" type="submit"
              ><font-awesome-icon icon="plus"></font-awesome-icon> Add</b-button
            >
            <b-table
              :fields="fields"
              :items="tax"
              responsive="sm"
              class="align-items-center mt-3 text-center"
            >
              <template #cell(name)="row">
                <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
              </template>

              <!-- <template #cell(actions)="row"> -->
              <!-- <a
                    v-if="canDelete"
                    v-on:click="deleteTax(row)"
                    v-b-tooltip.hover.left
                    title="Delete"
                    class="btn-op icon-delete mr-2"
                  ></a>
                  <a
                    v-else
                    v-on:click="deleteTax()"
                    v-b-tooltip.hover.left
                    title="Delete"
                    class="btn-op icon-delete mr-2"
                  ></a> -->

              <!-- <a
                      v-if="canEdit"
                      v-on:click="showModalEditTax(row)"
                      v-b-tooltip.hover.right
                      title="Edit"
                      class="btn-op icon-edit mr-1"
                    ></a>
                    <a
                      v-else
                      v-on:click="showModalEditTax(row)"
                      v-b-tooltip.hover.right
                      title="Edit"
                      class="btn-op icon-edit mr-1"
                    ></a> -->
              <!-- </template> -->
            </b-table>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { Money } from 'v-money';
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');

export default {
  components: { Money },
  data() {
    return {
      apiUrl: {
        cashIn: window.AppConfig.apiUrl + 'cash',
        journal: window.AppConfig.apiUrl + 'journal-account',
        purchase: window.AppConfig.apiUrl + 'purchase',
      },
      isLoading: false,
      isCustomItem: false,
      isDeleted: false,
      isCustomDiscount: false,
      value: '',
      availableItems: [],
      selectedItems: [],
      selectedItem: {},
      company: '',
      companyUuid: '',
      branch: '',
      branchUuid: '',
      taxesValue: '',
      currency: '',
      totalSubtotal: 0,
      totalTaxValue: 0,
      supplierData: [],
      loadingButton: false,
      i: 1,
      accountName: '',
      token: this.$store.getters['account/tokens'].access_token,
      details: '',
      totalCash: 0,
      totalCashIn: 0,
      purchaseDataObject: [],
      taxList: [],
      isBankAccount: [],
      dataAccountName: [],
      journalAccountList: [],
      customerList: [],
      model: {
        cashNumber: '',
        supplier: '',
        purchaseId: '',
        bankAccount: '',
        purchaseDate: '',
        purchaseNote: '',
        purchaseItem: [],
        purchaseHistoryPayment: [],
        purchaseTotalDiscount: 0,
        tax: '',
        taxValue: null,
        status: null,
        note: '',
        createdBy: this.$store.getters['account/accountData'].uuid,
      },
      formData: {
        paymentDate: null,
        paidBy: '',
        uuid: '',
        paymentTo: '',
        paymentRefNumber: '',
        paymentAmmount: 0,
        paymentNote: '',
      },
      cashTransactionDebit: [],
      cashTransactionCredit: [],
      dataCreditCash: [],
      cashInData: [],
      bankList: [],
      dataPayment: [],
      taxUuid: '',
      //formatter curency
      money: {
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false,
      },
      tax: "",
      fields: []
    };
  },

  computed: {
    // disable() {
    //   if (this.cashDataObject.length !== 0) {
    //     return true;
    //   }
    //   return false;
    // },
  },

  watch: {
    'model.taxValue'(value) {
      this.getTaxByValue(value);
    },
  },

  mounted() {
    this.getBankList();
    this.fetchAvailableItems();
    this.getRemainingAvailableItems();
    this.getSupplier();
    this.getTax();
    this.getTaxModelValue();
    this.getJournal();
    this.triggerData();
    this.getDiscTotalCustom();
  },

  methods: {
    getAvailableItems() {
      this.$http.get(window.AppConfig.apiUrl + 'item-list').then((resp) => {
        this.availableItems = [];
        resp.data._embedded.item_list.forEach((data) => {
          this.availableItems.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    //get bank account
    getBankList() {
      this.$http
        .get(window.AppConfig.apiUrl + 'bank-account')
        .then((response) => {
          this.bankList = [];
          response.data._embedded.bank_account.forEach((data) => {
            this.bankList.push({
              value: data.uuid,
              text: data.bank,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    //get supplier
    getSupplier() {
      this.$http
        .get(window.AppConfig.apiUrl + 'supplier')
        .then((response) => {
          this.supplierData = [];
          response.data._embedded.supplier.forEach((data) => {
            this.supplierData.push({
              value: data.uuid,
              text: data.name,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    getJournal() {
      this.$http
        .get(window.AppConfig.apiUrl + 'journal-account?journalAccountType=D')
        .then((resp) => {
          this.journalAccountList = [];
          resp.data._embedded.journal_account.forEach((data) => {
            this.journalAccountList.push({
              value: data.uuid,
              text:
                data.journalAccountCode +
                ' - ' +
                data.journalAccountType +
                ' - ' +
                data.journalAccountName,
            });
          });
        });
    },

    /**
     * berfungsi sebagai perhitungan pajak
     * saat membuat purchase baru
     */
    getTaxModelValue() {
      if (this.model.taxValue !== null) {
        this.getTaxByValue(this.model.taxValue);
      }
    },

    //get tax from server
    getTax() {
      this.$http
        .get(window.AppConfig.apiUrl + 'tax-value')
        .then((response) => {
          this.taxList = [{ value: null, text: 'Select Tax' }];
          response.data._embedded.tax_value.forEach((data) => {
            this.taxList.push({
              value: data.uuid,
              text: data.name,
            });
          });
        })
        .catch((error) => {
          window.consoleLog(error);
        });
    },

    /**
     * get tax value from tax category detail
     * return is value
     */
    getTaxByValue(uuid) {
      if (this.$route.params.uuid !== undefined) {
        let totalTaxValue = 0;
        this.$http
          .get(window.AppConfig.apiUrl + 'tax-value' + '/' + this.taxUuid)
          .then((response) => {
            this.taxesValue = response.data.value;
            this.totalTaxValue = (this.taxesValue * this.taxesValue) / 100;
          });
      } else {
        let totalTaxValue = 0;
        this.$http
          .get(window.AppConfig.apiUrl + 'tax-value' + '/' + uuid)
          .then((response) => {
            this.taxesValue = response.data.value;
            this.totalTaxValue = (this.taxesValue * this.taxesValue) / 100;
          })
          .catch((error) => {
            window.consoleLog(error);
          });
      }
    },

    /*
     * counting subtotal
     */
    getSubtotal: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
      });
      return subtotal;
    },

    /*
     * counting total tax
     */
    // getTaxValues: function() {
    //   let subtotal = 0;
    //   let taxValued = 0;
    //   this.selectedItems.forEach(({orderQuantity, price, discount}) => {
    //     subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount / 100))
    //     taxValued = subtotal * this.taxesValue / 100
    //   });
    //   return taxValued;
    // },

    /*
     * counting total price
     */
    getTotal: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
      });
      return totalSubtotal;
    },

    /**
     * use to show pop up payment purchase.
     */
    showModalPurchasePay() {
      this.dataPayment.slice();
      this.formData.paymentDate = null;
      this.formData.paymentRefNumber = null;
      this.formData.paymentTo = null;
      this.formData.paymentAmmount = 0;
      this.formData.paymentNote = '';
      this.$bvModal.show('bv-modal-invoice-pay');
      this.getBankList();
    },

    /**
     * add data payment, but this not send to server
     * because only crud,
     * data send to server if we submit form create purchase
     */
    doPaymentInvoice() {
      this.dataPayment.push({
        date: this.formData.paymentDate,
        refNumber: this.formData.paymentRefNumber,
        payTo: this.formData.paymentTo,
        payAmmount: this.formData.paymentAmmount,
        payNote: this.formData.paymentNote,
        paidBy: this.formData.paidBy,
      });
      this.$bvModal.hide('bv-modal-invoice-pay');
      console.log('data pembayaran', this.dataPayment);
    },

    deletePayment(i) {
      this.dataPayment.splice(i, 1);
    },
    /**
     * untuk menghitung total cash
     */
    sumCashIn() {
      let subtotal = 0;
      this.cashDataObject.forEach(({ totalCashCredit }) => {
        subtotal = subtotal + totalCashCredit++;
      });
      return subtotal;
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    /**
     * @function fetchAvailableItems
     * @async
     * fetch items for sale from API then remap it
     * by adding OrderQuantity and isManuallyEntered
     */
    fetchAvailableItems: async function() {
      const response = await this.$http.get(window.AppConfig.apiUrl + 'item-list');
      this.dataItem = response.data._embedded.item_list.name;
      this.availableItems = response.data._embedded.item_list.map((availableItem) => ({
        uuid: availableItem.uuid,
        name: availableItem.name,
        normalPrice: availableItem.normalPrice,
        corporatePrice: availableItem.corporatePrice,
        taxValue: availableItem.taxValue,
        orderQuantity: 0,
        price: 0,
        discount: 0,
        amount: 0,
        isCustomItem: false,
        isDeleted: false,
        // timezone: availableItem.account.currency
      }));
    },

    /**
     * @function addToSelected
     * @param {{ isManuallyEntered, name, orderQuantity, price, discount, uuid }} item
     * add the item object into selectedItems array.
     */
    addToSelected: function(item) {
      this.selectedItems.push(item);
      console.log(this.selectedItems);
    },

    /**
     * @function createCustomItem
     * create an empty input fields to enter items
     * that is currently not in the database.
     */
    createCustomItem: function() {
      this.addToSelected({
        uuid: '',
        name: '',
        price: 0,
        taxValue: null,
        orderQuantity: 0,
        discount: 0,
        amount: 0,
        isCustomItem: true,
        isDeleted: false,
      });
      console.log(this.selectedItems);
    },

    /**
     * @function deleteSelectedItem    },
     */
    deleteSelectedItem: function(index) {
      this.selectedItems.splice(index, 1);
    },

    /**
     * @function getRemainingAvailableItems
     * get availableItems that is not yet added into selectedItems
     * by extracting UUIDs from selectedItems into selectedItemsUUID array
     * then filter out items whose UUID is in the selectedItemsUUID array.
     */
    getRemainingAvailableItems: function() {
      const selectedItemsUUID = this.selectedItems.map(({ uuid }) => uuid);
      return this.availableItems.filter(
        (availableItem) => !selectedItemsUUID.includes(availableItem.uuid),
      );
    },

    /*
     * counting subtotal
     */
    getSubtotal: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
      });
      return subtotal;
    },

    /*
     * counting total tax
     */
    getTaxValues: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    /*
     * counting total price
     */
    getSubtotalCustom: function() {
      let subtotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price }) => {
        subtotal = subtotal + orderQuantity * price;
      });
      return subtotal;
    },

    getDiscTotalCustom: function() {
      let disctotal = 0;
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        disctotal = disctotal + (orderQuantity * price * discount) / 100;
        if (discount > 0) {
          this.isCustomDiscount = false;
        } else if (discount == 0) {
          this.isCustomDiscount = true;
        }
      });
      return disctotal;
    },

    getTotalCustomOrder() {
      let totalOrder = 0;
      let finalTotalOrder = 0
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        totalOrder =
          totalOrder + (orderQuantity * price - (orderQuantity * price * discount) / 100);
          finalTotalOrder = totalOrder - this.model.purchaseTotalDiscount
        } 
      );
      return finalTotalOrder;
    },

    getTaxValuesCustom: function() {
      let subtotal = 0;
      let taxValued = 0;
      let finalTotalOrder = 0
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        finalTotalOrder = subtotal - this.model.purchaseTotalDiscount
        taxValued = (finalTotalOrder * this.taxesValue) / 100;
      });
      return taxValued;
    },

    getTotalCustom: function() {
      let subtotal = 0;
      let totalSubtotal = 0;
      let taxValued = 0;
      let finalTotalOrder = 0
      let grandTotal = 0
      this.selectedItems.forEach(({ orderQuantity, price, discount }) => {
        subtotal = subtotal + (orderQuantity * price - (orderQuantity * price * discount) / 100);
        finalTotalOrder = subtotal - this.model.purchaseTotalDiscount
        taxValued = (finalTotalOrder * this.taxesValue) / 100;
        // totalSubtotal = subtotal + (subtotal * this.taxesValue) / 100;
        grandTotal =  finalTotalOrder + taxValued
      });
      return grandTotal;
    },


    /**
     * crud table untuk menambahkan row
     */
    addDataCash() {
      let r = this;
      r.purchaseDataObject.push({
        i: +1,
        journalAccount: null,
        details: '',
        discount: 0,
        quantity: 0,
        price: 0,
      });
    },

    /**
     * show modal for input data tax to database
     */
    showModalTax() {
      this.formData.name = null;
      this.formData.value = null;
      this.formData.journalAccount = null;
      this.$bvModal.show('bv-modal-tax');
    },

    /**
     * post data tax to database
     */
    doAddTax() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + 'tax-value', {
          name: this.formData.name,
          value: this.formData.value,
          journalAccount: this.formData.journalAccount,
        })
        .then((resp) => {
          this.isLoading = false;
          this.formData.name = null;
          this.formData.note = null;
          this.formData.journalAccount = null;
          // this.getTax();
          // this.getTaxValue();
          this.$bvModal.hide('bv-modal-tax');
          this.$store.dispatch('notification/success', 'Tax has been added');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },


    getTotalDiscount() {
      let totalDisc = 0;
      this.purchaseDataObject.forEach(({ discount, quantity, price }) => {
        totalDisc = totalDisc + (quantity * price * discount) / 100;
      });
      return totalDisc;
    },

    getTotalAfterDiscount() {
      let totalOrder = 0;
      this.purchaseDataObject.forEach(({ discount, quantity, price }) => {
        if( discount !==0 ){
          totalOrder = totalOrder + (quantity * price - (quantity * price * discount) / 100)
        } else {
          totalOrder = totalOrder + (quantity * price) - this.model.purchaseTotalDiscount
        }
      });
      return totalOrder;
    },

    /*
     * counting total tax
     */
    getTaxValues: function() {
      let subtotal = 0;
      let taxValued = 0;
      this.purchaseDataObject.forEach(({ quantity, price, discount }) => {
        subtotal = subtotal + (quantity * price - (quantity * price * discount) / 100);
        taxValued = (subtotal * this.taxesValue) / 100;
      });
      return taxValued;
    },

    /**
     * get grand total
     */
    getGrandTotal() {
      let total = 0;
      let grandTotal = 0;
      this.purchaseDataObject.forEach(({ quantity, price, discount }) => {
        total = total + (quantity * price - (quantity * price * discount) / 100);
        grandTotal = total + (total * this.taxesValue) / 100;
      });
      console.log(total);
      return grandTotal;
    },

    /**
     * triger get Data detail
     */
    triggerData() {
      if (this.$route.params.uuid !== undefined) {
        this.getDetails();
      }
    },


    /**
     * get detail if route.params.uuid !== undefined
     * use in page edit purchase
     */
    getDetails() {
      this.$http.get(this.apiUrl.purchase + '/' + this.$route.params.uuid).then((response) => {
        console.log('response :', response);
        let tax = response.data.taxValue.name;
        this.model.bankAccount = response.data.bankAccount ? response.data.bankAccount.bank : '';
        this.model.supplier = response.data.supplier ? response.data.supplier.name : '';
        this.model.taxValue = response.data.taxValue ? response.data.taxValue.name : '';
        this.model.taxValue = tax;
        this.model.purchaseId = response.data.purchaseId ? response.data.purchaseId : '';
        this.model.purchaseDate = response.data.purchaseDate
          ? this.$moment(response.data.purchaseDate).format('YYYY-MM-DD')
          : null;
        this.model.purchaseNote = response.data.purchaseNote ? response.data.purchaseNote : '';
        this.taxUuid = response.data.taxValue !== null ? response.data.taxValue.uuid : '';
        if (response.data.purchaseItem !== null) {
          response.data.purchaseItem.map((item) => {
            this.purchaseDataObject.push({
              itemUuid: item.itemList !== null ? item.itemList.uuid : item.itemList.uuid,
              name: item.itemList.name,
              quantity: item.price !== null ? item.quantity : 0,
              price: item.price !== null ? item.price : 0,
              discount: item.discount ? item.discount : 0,
            });
            console.log('item:', this.purchaseDataObject);
          });
          response.data.purchaseItem.map((item) => {
            this.availableItems.push({
              name: item.name,
              value: item.value,
            });
          });
        }
        this.getTaxByValue();
      });
    },

    /**
     * method POST untuk kirim data ke server
     *
     */
    postPurchase() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loadingButton = true;
          const toItem = this.selectedItems.map((selectedItem) => ({
            uuid: '',
            itemList: selectedItem.uuid,
            quantity: selectedItem.orderQuantity,
            discount: selectedItem.discount,
            price: selectedItem.price,
            delete: selectedItem.isDeleted ? 0 : 1,
          }));
          const toPayment = this.dataPayment.map((payment) => ({
            uuid: '',
            paymentDate: payment.date,
            paymentTo: payment.payTo,
            paymentRefNumber: payment.refNumber,
            paymentAmmount: payment.payAmmount,
            paymentNote: payment.payNote,
          }));
          let formData = new FormData();
          formData.append('bankAccount', this.model.bankAccount);
          formData.append('supplier', this.model.supplier); 
          formData.append('taxValue', this.model.taxValue);
          formData.append('purchaseId', this.model.purchaseId);
          formData.append('purchaseDate', this.model.purchaseDate);
          formData.append('purchaseNote', this.model.purchaseNote);
          formData.append('purchaseTotalDiscount', this.model.purchaseTotalDiscount);
          formData.append('purchaseItem', JSON.stringify(toItem));
          formData.append('purchaseHistoryPayment', JSON.stringify(toPayment));
          if (this.$route.params.uuid !== undefined) {
            this.$http
              .patch(this.apiUrl.purchase + '/' + this.$route.params.uuid, formData)
              .then((response) => {
                this.$store.dispatch('notification/success', 'Purchase data has been Added');
                window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
                setTimeout(() => {
                  // window.location.reload();
                  this.loadingButton = false;
                }, 1500);
              });
          } else {
            this.$http
              .post(this.apiUrl.purchase, formData)
              .then((response) => {
                this.$store.dispatch('notification/success', 'Purchase data has been Added');
                window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
                setTimeout(() => {
                  // window.location.reload();
                  this.loadingButton = false;
                }, 1500);
              });
          }
        }
      });
    },

    goBack() {
      window.goBack(this);
    },
    /**
     * formatter currency untuk data static
     */
    formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
};
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  /* background: #dfe5fb; */
  border: none;
  color: #394066;
}
</style>
